export default __webpack_public_path__ + "static/media/motoAutoValorSmall.44cae0ec.png";